// Chinese fake text library — matches cn.js structure with 出师表 placeholder text
import React from 'react';
import { profile as realProfile, experiences as realExperiences, education as realEducation } from './cn';

const SHIBIAO = '先帝创业未半而中道崩殂今天下三分益州疲弊此诚危急存亡之秋也然侍卫之臣不懈于内忠志之士忘身于外者盖追先帝之殊遇欲报之于陛下也诚宜开张圣听以光先帝遗德恢弘志士之气不宜妄自菲薄引喻失义以塞忠谏之路也宫中府中俱为一体陟罚臧否不宜异同若有作奸犯科及为忠善者宜付有司论其刑赏以昭陛下平明之理不宜偏私使内外异法也侍中侍郎郭攸之费祎董允等此皆良实志虑忠纯是以先帝简拔以遗陛下愚以为宫中之事事无大小悉以咨之然后施行必能裨补阙漏有所广益将军向宠性行淑均晓畅军事试用于昔日先帝称之曰能是以众议举宠为督愚以为营中之事悉以咨之必能使行阵和睦优劣得所亲贤臣远小人此先汉所以兴隆也亲小人远贤臣此后汉所以倾颓也先帝在时每与臣论此事未尝不叹息痛恨于桓灵也侍中尚书长史参军此悉贞良死节之臣愿陛下亲之信之则汉室之隆可计日而待也臣本布衣躬耕于南阳苟全性命于乱世不求闻达于诸侯先帝不以臣卑鄙猥自枉屈三顾臣于草庐之中咨臣以当世之事由是感激遂许先帝以驱驰后值倾覆受任于败军之际奉命于危难之间尔来二十有一年矣先帝知臣谨慎故临崩寄臣以大事也受命以来夙夜忧叹恐托付不效以伤先帝之明故五月渡泸深入不毛今南方已定兵甲已足当奖率三军北定中原庶竭驽钝攘除奸凶兴复汉室还于旧都此臣所以报先帝而忠陛下之职分也至于斟酌损益进尽忠言则攸之祎允之任也愿陛下托臣以讨贼兴复之效不效则治臣之罪以告先帝之灵若无兴德之言则责攸之祎允等之慢以彰其咎陛下亦宜自谋以咨诹善道察纳雅言深追先帝遗诏臣不胜受恩感激今当远离临表涕零不知所言';

function fakeOfLength(n) {
  if (n === 0) return '';
  const maxStart = Math.max(SHIBIAO.length - n, 1);
  const start = Math.floor(Math.random() * maxStart);
  return SHIBIAO.slice(start, start + n);
}

// Structural keys preserved as-is (links → github.com)
const PRESERVE_KEYS = new Set(['type', 'id']);
const LINK_KEYS = new Set(['url', 'headerLink']);

function fakeString(str) {
  // Replace 4-digit years → 2077, keep "至今", dashes and commas unchanged, fake the rest
  const parts = [];
  const regex = /\b\d{4}\b|至今|[-–,， ]/g;
  let lastIdx = 0, match;
  while ((match = regex.exec(str)) !== null) {
    if (match.index > lastIdx) {
      parts.push(fakeOfLength(match.index - lastIdx));
    }
    const seg = match[0];
    if (/^\d{4}$/.test(seg)) {
      parts.push('2077');
    } else {
      parts.push(seg); // 至今, –, -, ,, ， all kept as-is
    }
    lastIdx = match.index + match[0].length;
  }
  if (lastIdx < str.length) {
    parts.push(fakeOfLength(str.length - lastIdx));
  }
  return parts.join('');
}

// Clone a JSX child, preserving element structure (li/a/ul/p), replacing text & links
function fakeJSXChild(child) {
  if (typeof child === 'string') return fakeOfLength(child.length);
  if (typeof child === 'number') return fakeOfLength(String(child).length);
  if (child && child.$$typeof) {
    const props = {};
    if (child.props.className) props.className = child.props.className;
    if (child.props.href) props.href = 'https://github.com/ericpzh';
    // Recursively process children to preserve nested structure (ul > li > a, etc.)
    const children = child.props.children != null
      ? React.Children.map(child.props.children, fakeJSXChild)
      : null;
    return React.createElement(child.type, props, children);
  }
  return String(child);
}

function fakeDeep(obj) {
  if (typeof obj === 'string') return fakeString(obj);

  if (typeof obj === 'object' && obj !== null) {
    if (Array.isArray(obj)) return obj.map(fakeDeep);

    // React elements (JSX) → preserve structure, replace links with github.com, fake text
    if (obj.$$typeof) {
      const children = fakeDeep(obj.props.children);
      const props = {};
      if (obj.props.href) props.href = 'https://github.com/ericpzh';
      if (obj.props.className) props.className = obj.props.className;
      return React.createElement(obj.type, props, children);
    }

    // Plain object — recurse into values
    const result = {};
    for (const key of Object.keys(obj)) {
      if (PRESERVE_KEYS.has(key)) {
        result[key] = obj[key];
      } else if (LINK_KEYS.has(key)) {
        result[key] = obj[key] ? 'https://github.com/ericpzh' : obj[key];
      } else if (key === 'details' && obj[key] && obj[key].$$typeof) {
        // Expandable item details (React element): preserve child count & text length per child
        const originalChildren = React.Children.toArray(obj[key].props.children);
        const fakedChildren = originalChildren.map(fakeJSXChild);
        result[key] = React.createElement(React.Fragment, null, ...fakedChildren);
      } else {
        result[key] = fakeDeep(obj[key]);
      }
    }
    return result;
  }
  return obj;
}

export const profile = fakeDeep(realProfile);
export const experiences = fakeDeep(realExperiences);
export const education = fakeDeep(realEducation);
